import React, { useState } from 'react';
import { Plus, Trash2, Save } from 'lucide-react';
import { toast } from 'sonner';
import { api, errMsg } from '../api';
import { inputCls, goldBtn, ghostBtn } from '../ui';

const fld = `${inputCls} h-9 px-2 text-sm border`;
const EMPTY = { title: '', severity: 'media', status: 'aperta', asset: '', due_date: '', note: '' };

export default function VulnEditor({ report, onSaved }) {
  const [rows, setRows] = useState(report.vulns || []);
  const set = (i, k, v) => setRows(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  const save = async () => {
    try { await api.put(`/cyber/vapt/reports/${report.id}/vulns`, rows.filter((r) => r.title.trim())); toast.success('Vulnerabilità salvate'); onSaved(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-3 space-y-2" data-testid={`vuln-editor-${report.id}`}>
      {rows.map((r, i) => (
        <div key={r.id || i} className="grid grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1fr_1fr_auto] gap-2" data-testid={`vuln-row-${i}`}>
          <input value={r.title} onChange={(e) => set(i, 'title', e.target.value)} placeholder="Vulnerabilità riscontrata" className={fld} data-testid={`vuln-title-${i}`} />
          <select value={r.severity} onChange={(e) => set(i, 'severity', e.target.value)} className={fld} data-testid={`vuln-severity-${i}`}>{['critica', 'alta', 'media', 'bassa'].map((x) => <option key={x}>{x}</option>)}</select>
          <select value={r.status} onChange={(e) => set(i, 'status', e.target.value)} className={fld} data-testid={`vuln-status-${i}`}><option value="aperta">Aperta</option><option value="in_lavorazione">In lavorazione</option><option value="risolta">Risolta</option></select>
          <input value={r.asset} onChange={(e) => set(i, 'asset', e.target.value)} placeholder="IP / rete" className={fld} data-testid={`vuln-asset-${i}`} />
          <input type="date" value={r.due_date} onChange={(e) => set(i, 'due_date', e.target.value)} title="Scadenza correzione" className={fld} data-testid={`vuln-due-${i}`} />
          <button onClick={() => setRows(rows.filter((_, j) => j !== i))} className="h-9 w-9 grid place-items-center text-[#7A7F87] hover:text-[#E5484D]" data-testid={`vuln-delete-${i}`}><Trash2 size={14} /></button>
        </div>
      ))}
      <div className="flex gap-2">
        <button onClick={() => setRows([...rows, { ...EMPTY }])} className={`${ghostBtn} h-9 px-3 text-sm inline-flex items-center gap-2`} data-testid={`vuln-add-${report.id}`}><Plus size={14} />Aggiungi vulnerabilità</button>
        <button onClick={save} className={`${goldBtn} h-9 px-3 text-sm inline-flex items-center gap-2`} data-testid={`vuln-save-${report.id}`}><Save size={14} />Salva</button>
      </div>
    </div>
  );
}
